import React from "react";
import "./About.css";

export default function About() {
  return (
    <div className="doc-layout-single">
      <article className="doc-main">
        <div className="doc-tag">ABOUT</div>
        <h1 className="doc-title">关于我</h1>
        <div className="doc-meta">个人简介、经历和兴趣。</div>
        <p className="doc-paragraph">
           111
        </p>
      </article>
    </div>
  );
}
